const paddingZero = function(value) {
    return value < 10
        ? '0' + value
        : value + '';
};

const dateFormat = function(val, format = 'yyyy-MM-dd hh:mm:ss') {
    if(!val) {
        return val;
    }

    let date = new Date(isNaN(Number(val)) ? val : Number(val));
    let result = '';

    //format 'yyyy'
    result = format.replace('yyyy', date.getFullYear())

    //format 'M|MM'
    let month = date.getMonth() + 1;
    if(format.search('MM') !== -1) {
        result = result.replace('MM', paddingZero(month))
    }
    else if(format.search(/M{1}/)) {
        result = result.replace('M', month)
    }

    //format 'd|dd'
    let day = date.getDate();
    if(format.search('dd') !== -1) {
        result = result.replace('dd', paddingZero(day))
    }
    else if(format.search(/d{1}/)) {
        result = result.replace('d', day)
    }

    //format 'h|hh'
    let hours = date.getHours();
    if(format.search('hh') !== -1) {
        result = result.replace('hh', paddingZero(hours))
    }
    else if(format.search(/h{1}/)) {
        result = result.replace('h', hours)
    }

    //format 'm|mm'
    let minutes = date.getMinutes();
    if(format.search('mm') !== -1) {
        result = result.replace('mm', paddingZero(minutes))
    }
    else if(format.search(/m{1}/)) {
        result = result.replace('m', hours)
    }

    //format 's|ss'
    let seconds = date.getSeconds();
    if(format.search('ss') !== -1) {
        result = result.replace('ss', paddingZero(seconds))
    }
    else if(format.search(/s{1}/)) {
        result = result.replace('s', seconds)
    }

    return result;
};

export {
    paddingZero,
    dateFormat,
}